import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import fortContent from "./fortContent";
import districtData from "./districtData";

const SingleMonumentPage = () => {
  const sliderRef = useRef(null);
  const { divisionName, districtName, fortId } = useParams();
  const selectedLang = useSelector((state) => state.language.selectedLang);
  const content = fortContent[fortId]?.[selectedLang];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const navigate = useNavigate();
 let currentDistrictKey = null;

  // Search in all districts to find the monument and its district
  for (const districtKey in districtData) {
    const monuments = districtData[districtKey]?.English?.cards;
    const found = monuments.find((mon) => mon.id === fortId);
    if (found) {
       currentDistrictKey = districtKey;
      break;
    }
  }


  const otherMonuments =
    currentDistrictKey && districtData[currentDistrictKey]?.[selectedLang]?.cards
      ? districtData[currentDistrictKey][selectedLang].cards.filter(
        (mon) => mon.id !== fortId
      )
      : [];


  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        (prevIndex + 1) % content?.imageGroup?.length
      );
    }, 10000);

    return () => clearInterval(interval);
  }, [content?.imageGroup?.length]);


  if (!content) {
    return (
      <div className="p-6 mt-20 text-red-500">
        Content not available for this monument.
      </div>
    );
  }

  const scrollSlider = (direction) => {
    const { current } = sliderRef;
    if (current) {
      const cardWidth = current.firstChild?.offsetWidth + 24; // card + gap
      current.scrollBy({
        left: direction === "left" ? -cardWidth : cardWidth,
        behavior: "smooth",
      });
    }
  };


// Before return (inside the component, above `return`)
const sliderJustifyClass = (() => {
  if (otherMonuments.length === 1) {
    return "justify-center"; // 1 → center everywhere
  }
  if (otherMonuments.length === 2 || otherMonuments.length === 3) {
    return "justify-start lg:justify-center"; // 2–3 → left on mobile, center on lg+
  }
  return "justify-start overflow-hidden"; // 4+ → left/scroll
})();



  return (
    <div className="bg-[#F6F6EC] px-4 py-12">
      {/* Title Section */}
      <div className="text-center mb-8">
        <h1 className="text-[26px] capitalize sm:text-4xl md:text-5xl lg:text-[45px] text-black text-center break-words max-w-[80%] mx-auto leading-snug">
          {/* Shirgaon Fort */}
          {content.title}
        </h1>
        <p className="font-futura tracking-wider text-sm sm:text-base lg:text-[15px] font-medium mt-2">
          <span style={{ color: "#DD9827" }}>
            <Link to="/" className="hover:underline">
              {content.breadcrumb}
            </Link>{" "}/{" "}
            <Link
              to={`/monuments/${divisionName}/${districtName}`}
              className="hover:underline uppercase"
              style={{ color: "#DD9827" }}
            >
              {content.breadcrumbMuseum}
            </Link>

          </span>
          {" "}/{" "} <span className="uppercase">{content.divisionTitle}</span>
        </p>
      </div>

      {/* Image + Ticket + Description */}
      <div className="flex flex-col lg:flex-row gap-10 max-w-7xl mx-auto px-4 lg:px-12 py-6">
        {/* Left Image Box */}
        <div className="bg-[#EFEDE0] border-2 border-[#F8D6BF] rounded-[34px] p-4 lg:w-1/2 max-w-md mx-auto lg:mx-0 text-center self-start">
          <div className="relative w-full max-w-md mx-auto">
            <img
              src={content.imageGroup[currentImageIndex]}
              alt={`Fort View ${currentImageIndex + 1}`}
              className="w-full h-48 object-cover rounded-md mb-4 transition-opacity duration-1000 opacity-90"
            />
            {/* Indicators */}
            <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2 flex space-x-2 bg-opacity-30 px-3 py-1 rounded-full z-10">
              {content.imageGroup.map((img, index) => (
                <button
                  key={img.id}
                  onClick={() => setCurrentImageIndex(index)}
                  className={
                    index === currentImageIndex
                      ? "w-6 h-3 bg-white rounded-md"
                      : "w-3 h-3 bg-white opacity-80 rounded-full"
                  }
                ></button>
              ))}

            </div>
          </div>
          <p className="text-[16px] text-[#1f1f1f] mt-4">
            {content.place} {content.city1}
          </p>
          <p className="text-[16px] text-[#1f1f1f]">
            {content.taluka} {content.taluka1}
          </p>
          <p className="text-[16px] text-[#1f1f1f]">
            {content.district} {content.district1}
          </p>
          <p className="text-[16px] text-[#1f1f1f]">
            {content.geographic}
            <br /> {content.geographic1}
          </p>
        </div>

        <div className="w-full flex flex-col gap-6 font-futura">
          {/* Description */}
          <div className="text-[14px] sm:text-lg md:text-xl lg:text-[17px] leading-[1.25rem] md:leading-[1.5rem] lg:leading-[1.5rem] text-justify">
            <p className="mb-4">
              {content.paragraph1}
            </p>
            <p className="mb-4">
              {content.paragraph2}
            </p>
            <p className="mb-4">
              {content.paragraph3}
            </p>
            <p className="mb-4">
              {content.paragraph4}
            </p>
            <p className="mb-4">
              {content.paragraph5}
            </p>
            <p className="mb-4">
              {content.paragraph6}
            </p>
            <p className="mb-4">
              {content.paragraph7}
            </p>
            <p className="mb-4">
              {content.paragraph8}
            </p>
            <p className="mb-4">
              {content.paragraph9}
            </p>
            <p className="mb-4">
              {content.paragraph10}
            </p>
            <p className="mb-4">
              {content.paragraph11}
            </p>
            <p className="mb-4">
              {content.paragraph12}
            </p>
            <p className="mb-4">
              {content.paragraph13}
            </p>
            <p className="mb-4">
              {content.paragraph14}
            </p>
            <p className="mb-4">
              {content.paragraph15}
            </p>
            <p className="mb-4">
              {content.paragraph16}
            </p>
          </div>
        </div>
      </div>

      {/* Nearby Attractions */}
      <div className="mt-20 px-4 sm:px-10">
        <h2 className="text-center text-2xl sm:text-3xl font-semibold text-gray-900 mb-6">
          {selectedLang === "मराठी" ? "जवळील आकर्षणे" : "Near By Attractions"}
        </h2>

        <div className="relative w-full max-w-6xl mx-auto px-4">
          {/* Slider Wrapper */}
          <div className="flex items-center justify-center relative">
            {/* Left Arrow */}
            {otherMonuments.length > 4 && (
              <button
                onClick={() => scrollSlider("left")}
                className="hidden lg:flex items-center justify-center w-10 h-10 -left-6 top-1/2 transform -translate-y-1/2 z-10 text-4xl"            >
                ←
              </button>
            )}

            {/* Slider */}
            <div
              ref={sliderRef}
              className={`flex gap-6 overflow-x-auto md:overflow-x-auto lg:overflow-x-hidden xl:overflow-x-hidden 
      scroll-smooth touch-pan-x no-scrollbar w-full ${sliderJustifyClass}`}
            >
              {otherMonuments.map((mon, index) => (
                <div
                  key={mon.id}
                  className={`
        flex-shrink-0 bg-white border-2 border-[#F8D6BF] rounded-[34px] p-4
        ${otherMonuments.length === 1 ? "w-[80%] sm:w-[60%] lg:w-1/3" : ""}
        ${otherMonuments.length === 2 ? "w-[90%] sm:w-[45%] lg:w-1/3" : ""}
        ${otherMonuments.length === 3 ? "w-[90%] sm:w-[40%] lg:w-1/4" : ""}
        ${otherMonuments.length >= 4 ? "w-[90%] sm:w-[48%] md:w-[31%] lg:w-[23%]" : ""}
      `}
                >
                  <img
                    src={mon.imageGroup[0]}
                    alt={mon.title}
                    className="w-full h-40 object-cover rounded-t-xl"
                  />
                  <div className="pt-4 text-center font-futura">
                    <h3 className="font-semibold text-gray-700 tracking-wide text-base sm:text-[12px] md:text-[14px] lg:text-[16px]">
                      {mon.title}
                    </h3>
                    <button
                      onClick={() =>
                        navigate(`/monuments/${divisionName}/${districtName}/${mon.id}`)
                      }
                      className="bg-[#D39100] text-white py-1 px-4 rounded-full hover:bg-[#c27f00] transition mt-2"
                    >
                      {mon.button}
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* Right Arrow */}
            {otherMonuments.length > 4 && (
              <button
                onClick={() => scrollSlider("right")}
                className="hidden lg:flex items-center justify-center w-10 h-10  -right-0 top-1/2 transform -translate-y-1/2 z-10 text-4xl"            >
                →
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleMonumentPage;
